<!-- 
  COMPONENT Projects
-->


<!---------- SCRIPT ---------->

<script lang="ts" type="module">

	// TODO notation A+
	
	import { onMount } from "svelte";
	import { 
		deglingos,
		minitel,
		english, 
	} from "../store/store";
	import ProjectComponent from "../components/Project.svelte";
	import type { Project } from "../models/project";
	import { storeNotificationClicked } from "../js/toaster";


	onMount(async () => {
		window.scrollTo(0, 0);
		storeNotificationClicked.set(true);
	})

	const projects: Project[] = [];
	const projectsEN: Project[] = [];

	const cardVilleSimplement: Project = {
		title: "Ville Simplement",
		image: "../images/project_villesimplement.jpeg",
		description: [
			"Assocation Ville Simplement",
			"Un petit laboratoire d’innovation sociale sur les quartiers populaires",
		],
		url: "https://villesimplement.fr",
	};
	projects.push(cardVilleSimplement);

	const cardVilleSimplementEN: Project = {
		title: "Ville Simplement",
		image: "../images/project_villesimplement.jpeg",
		description: [
			"Association Ville Simplement",
			"A small laboratory of social innovation in working-class neighborhoods",
		],
		url: "https://villesimplement.fr",
	};
	projectsEN.push(cardVilleSimplementEN);

	const cardMGO: Project = {
		title: "Mon grand l'ombre",
		image: "../images/project_mongrandlombre.svg",
		description: [
			"Compagnie de théatre Mon grand l'ombre",
			"Tresser musique et cinéma dans un cadre scénique et, par ces frictions de disciplines, raconter des histoires autrement",
		],
		url: "https://mongrandlombre.com",
	};
	projects.push(cardMGO);

	const cardMGOEN: Project = {
		title: "Mon grand l'ombre",
		image: "../images/project_mongrandlombre.svg",
		description: [
			"Theater company Mon grand l'ombre",
			"Weave music and cinema in a scenic setting and, through these frictions of disciplines, tell stories differently",
		],
		url: "https://mongrandlombre.com",
	};
	projectsEN.push(cardMGOEN);

	const cardAttal: Project = {
		title: "Attal Services",
		image: "../images/project_attal.png",
		description: [
			"Entreprise Attal Services",
			"Services d’assainissement, de viabilisation et d'aménagements pour particuliers sur la Loire Atlantique",
		],
		url: "https://attalservices.fr",
	};
	projects.push(cardAttal);

	const cardAttalEN: Project = {
		title: "Attal Services",
		image: "../images/project_attal.png",
		description: [
			"Company Attal Services",
			"Sanitation, servicing and development services for individuals in the Loire Atlantique",
		],
		url: "https://attalservices.fr",
	};
	projectsEN.push(cardAttalEN);

	const cardCollectifApiThinkingFR: Project = {
		title: "Collectif API Thinking",
		image: "../images/project_collectif_api_thinking.svg",
		description: [
			"Collectif API Thinking",
			"Depuis 2020, le 1er collectif français dédié aux APIs",
		],
		url: "https://www.collectif-api-thinking.com",
	};
	projects.push(cardCollectifApiThinkingFR);

	const cardCollectifApiThinkingEN: Project = {
		title: "Collectif API Thinking",
		image: "../images/project_collectif_api_thinking.svg",
		description: [
			"Collectif API Thinking",
			"Since 2020, the first french collective dedicated to APIs",
		],
		url: "https://www.collectif-api-thinking.com",
	};
	projectsEN.push(cardCollectifApiThinkingEN);

	// Projet AUNE abandonné
	//
	// const cardAuneFR: Project = {
	// 	title: "Agence Aune",
	// 	image: "../images/project_aune.svg",
	// 	description: [
	// 		"Agence Aune",
	// 		"Mill agence architecture et urbanisme",
	// 	],
	// 	url: "https://www.aune.fr",
	// };
	// projects.push(cardAuneFR);

	// const cardAuneEN: Project = {
	// 	title: "Aune agency",
	// 	image: "../images/project_aune.svg",
	// 	description: [
	// 		"Aune agency",
	// 		"Mill architecture and urban planning agency",
	// 	],
	// 	url: "https://www.aune.fr",
	// };
	// projectsEN.push(cardAuneEN);

	const cardPtceFR: Project = {
		title: "PTCE",
		image: "../images/project_ptce.svg",
		description: [
			"PTCE",
			"Les Pôles territoriaux de coopération économique",
		],
		url: "https://www.info-ptce.fr",
	};
	projects.push(cardPtceFR);

	const cardPtceEN: Project = {
		title: "PTCE",
		image: "../images/project_ptce.svg",
		description: [
			"PTCE",
			"Territorial poles of economic cooperation",
		],
		url: "https://www.info-ptce.fr",
	};
	projectsEN.push(cardPtceEN);

	const cardIkoboxFR: Project = {
		title: "ikobox",
		image: "../images/project_ikobox.svg",
		description: [
			"ikobox",
			"Entrepreneur, expert-comptable ou professionnel, simplifiez votre gestion administrative avec nos solutions",
		],
		url: "https://www.ikobox.fr/",
	};
	projects.push(cardIkoboxFR);

	const cardIkoboxEN: Project = {
		title: "ikobox",
		image: "../images/project_ikobox.svg",
		description: [
			"ikobox",
			"Entrepreneur, accountant or professional, simplify your administrative management with our solutions",
		],
		url: "https://www.ikobox.fr/",
	};
	projectsEN.push(cardIkoboxEN);

</script>


<!---------- STYLE ---------->

<style lang="scss">

	.pageContent {
		justify-content: flex-start;
	}
	.section {
		min-height: 70vh;
		&__deglingos {
			border-radius: 15% 15% 15% 15%;
		}
	}

	.article {
		&__p {
			text-align: left;
		}
	}

	.catalogue {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		width: 100%;
		margin: 32px 0 32px 0;
		flex-wrap: wrap;
	}

	@include medium {
		.catalogue {
			flex-direction: row;
			flex-wrap: wrap;
			&__minitel {
				flex-direction: column;
			}
		}
	}

	@include large {
		.section {
			padding: 0 16px 0 16px;
			align-items: flex-start;
			&__deglingos {
				margin: 0 32px 32px 32px;
			}
		}

		.article {
			width: 100%;
			&__deglingos {
				align-items: center;
			}
		}
		.catalogue {
			flex-direction: row;
			flex-wrap: wrap;
			&__minitel {
				flex-direction: column;
			}
		}
	}
</style>


<!---------- TEMPLATE ---------->

<div class="pageContent">
	{#if $english}
		<h1 class="article__h1" class:article__minitel__h1={$minitel}>PROJECTS</h1>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<div class="catalogue" class:catalogue__minitel={$minitel}>
					{#each projectsEN as projectEn}
    					<ProjectComponent props={projectEn}/>
					{/each}
				</div>
			</article>
		</section>
	{:else}
		<h1 class="article__h1" class:article__minitel__h1={$minitel}>PROJETS</h1>
		<section class="section" class:section__minitel={$minitel} class:section__deglingos={$deglingos}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
			>
				<div class="catalogue" class:catalogue__minitel={$minitel}>
					{#each projects as project}
    					<ProjectComponent props={project}/>
					{/each}
				</div>
			</article>
		</section>
	{/if}
</div>